import Button from "@gcs/design-system/react/components/Button";
import styled from "styled-components/macro";

export const ContainerBaseBoard = styled.section(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  background: theme.color.brandPrimary.light,
  padding: "64px 16px 64px 16px",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  marginBottom: "40px",

  h2: {
    fontSize: "32px",
    color: "#FFFFFF",
  },
  p: {
    fontSize: "18px",
    color: "#FFFFFF",
    lineHeight: "160%",
    fontWeight: "500",

    [theme.breakpoint.xl()]: {
      fontSize: "20px",
      padding: "0px 16px",
    },
  },

  [theme.breakpoint.xl()]: {
    padding: "128px 112px 128px 112px",
    
    h2: {
      fontSize: "40px",
      padding: "0px 16px",
    },
  },

  "@media (min-width: 1480px)": {
    padding: "128px calc((100% - 1260px)/2)",
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(219.26deg, #FF298C 0%, #D70064 76.43%)",
  borderRadius: "8px",
  marginTop: "20px",
  fontSize: "14px",
  fontWeight: 700,
  [theme.breakpoint.xl()]: {
    fontSize: "16px",
    marginLeft: "16px",
  },
}));
